module.exports = __webpack_public_path__ + "img/featuredartist15 (1).15d394db.jpg";